import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { twJoin } from "tailwind-merge";

import { Icon } from "src/base-components/Icon";
import { FolderVariant } from "src/flowsOverview/v2/Folder";

export type Props = {
  onRequestAddFolder: () => void;
  variant?: FolderVariant;
};

const styles: Record<FolderVariant, string> = {
  default:
    "sticky bottom-0 flex w-full min-w-0 items-center gap-x-2 rounded border-gray-200 border-t bg-gray-100 px-2 py-1.5 text-indigo-600",
  sidebar:
    "sticky bottom-0 flex w-[203px] items-center px-2 py-1.5 text-indigo-600 bg-white hover:bg-gray-50 rounded-lg",
};

export const AddFolder: React.FC<Props> = ({
  onRequestAddFolder,
  variant = "default",
}) => {
  const folderIcon = (
    <Icon
      color="text-gray-500"
      icon={faPlus}
      padding={variant !== "sidebar"}
      size={variant === "sidebar" ? "xs" : "base"}
    />
  );

  return (
    <button
      className={twJoin(styles[variant])}
      data-loc="add-folder"
      onClick={onRequestAddFolder}
    >
      {variant === "sidebar" && (
        <div className="py-0.5 pr-2.5 pl-0.5">{folderIcon}</div>
      )}
      {variant === "default" && folderIcon}
      <span className="grow truncate text-left font-inter-medium-13px">
        Add folder
      </span>
    </button>
  );
};
